import styled from '../../styles/styled';
import { getFontStyles, getBorderStyles, getKindStyles, getSizing, getIconSizing, getIconColor, } from './helpers';
export const Button = styled.button `
  position: relative;
  margin: 0;
  border: none;
  text-decoration: none;
  overflow: hidden;
  background: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) => {
    const { theme, fullWidth, kind, shape, size, color, } = props;
    /**
     * * Other implementation would be get the styles as per attributes
     * * like getColor/getBorder/getTypography etc
     */
    const fonts = getFontStyles({ theme, size });
    const borders = getBorderStyles({
        theme,
        shape,
        kind,
        size,
    });
    const sizing = getSizing({
        kind, theme, size, shape,
    });
    const kindStyles = getKindStyles({ theme, kind, color });
    // ! TODO: Huge refactor is under works
    /*
    const shapeStyles = getShapeStyles({ theme, shape }); */
    return {
        ...fonts,
        ...borders,
        ...sizing,
        ...kindStyles,
        /*
        ...shapeStyles, */
        ...(fullWidth && { width: '100%' }),
    };
}}

  &:focus {
    outline: none;
  }

  &:disabled {
    cursor: default;
  }
`;
export const LeadingIcon = styled.i `
  margin-right: ${({ theme, children }) => (children ? (theme.spacing.spacing20) : null)};
  line-height: 0;
  svg {
    ${({ size }) => getIconSizing({ size })}
  }
  svg path {
    fill: ${({ theme, kind, color, disabled, }) => getIconColor({
    theme, kind, color, disabled,
})};
  }
`;
export const TrailingIcon = styled.i `
  text-align: ${({ fullWidth }) => (fullWidth ? 'right' : null)};
  flex: ${({ fullWidth }) => (fullWidth ? 'auto' : 'none')};
  margin-left: ${({ theme, children }) => (children ? (theme.spacing.spacing20) : null)};
  line-height: 0;
  svg {
    ${({ size }) => getIconSizing({ size })}
  }
  svg path {
    fill: ${({ theme, kind, color, disabled, }) => getIconColor({
    theme, kind, color, disabled,
})};
  }
`;
